module.exports = __webpack_public_path__ + "static/media/ANSIEDADE.5c15e37a.png";